import { Deserializable } from './deserializable.interface';

/**
 * Container class for OCPP settings
 *
 * @export
 * @class OcppSettings
 * @implements {Deserializable}
 */
export class OcppSettings implements Deserializable {
  uri: string;
  secureUri: string;
  userId: string;
  username: string;
  ocppAuthenticationRequiredForAccount: boolean;
  ocppAuthenticationBasicAuthSecret: string;
  isReadonly: boolean;

  deserialize(input: any): this {
    this.uri = input.Uri;
    this.secureUri = input.SecureUri;
    this.userId = input.UserId;
    this.username = input.Username;
    this.ocppAuthenticationRequiredForAccount =
      input.OcppAuthenticationRequiredForAccount;
    this.ocppAuthenticationBasicAuthSecret =
      input.OcppAuthenticationBasicAuthSecret;
    this.isReadonly = input.IsReadonly;
    return this;
  }
}
